var $35f163cf34011e4d$exports = {};
$35f163cf34011e4d$exports = {
    "breadcrumbs": `Drobtine`
};


export {$35f163cf34011e4d$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
